import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "reactstrap";
import {
  ClientDetailDto,
  ClientPurchasedPackageDto,
} from "src/store/clients/type";
import DataGrid from "src/components/Page/Datagrid";
import { getClientPurchasedPackageList } from "src/store/clients/saga";
import { GetLocaleDate } from "src/helpers/getLocaleDate";
import AssignPackageModal from "./assignModal";

const ClientPurchasedPackagesTab = ({
  client,
  active,
}: {
  active: string;
  client: ClientDetailDto;
}) => {
  const { t } = useTranslation();
  const [dataList, setDataList] = useState<ClientPurchasedPackageDto[]>([]);
  const [showAssign, setShowAssign] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);
  const columns = [
    {
      text: t("Clients.Packages.Name"),
      dataField: "PackageName",
    },
    {
      text: t("Clients.Packages.PurchaseDate"),
      dataField: "PurchaseDate",
      formatter: (cellContent: any, data: any) => GetLocaleDate(cellContent),
    },
    {
      text: t("Clients.Packages.StartDate"),
      dataField: "PackStratDate",
      formatter: (cellContent: any, data: any) => GetLocaleDate(cellContent),
    },

    {
      text: t("Clients.Packages.EndDate"),
      dataField: "PackEndDate",
      formatter: (cellContent: any, data: any) => GetLocaleDate(cellContent),
    },
    {
      text: t("Clients.Packages.Period"),
      dataField: "IsMonth",
      formatter: (cellContent: any, data: any) => {
        const years =
          (new Date(data.PackEndDate).getTime() -
            new Date(data.PackStratDate).getTime()) /
          (365.25 * 24 * 3600 * 1000);
        if (years >= 50) return <>{t("Lifetime", "Süresiz")}</>;
        return <>{cellContent ? <>{t("Monthly")}</> : <>{t("Yearly")}</>}</>;
      },
    },
    {
      text: t("Clients.Packages.Paid"),
      dataField: "Paid",
      formatter: (cellContent: any, data: any) =>
        cellContent ? (
          <i className="fas fa-check-square text-success" />
        ) : (
          <i className="fas fa-exclamation-triangle text-danger" />
        ),
    },
  ];

  return (
    <React.Fragment>
      {active === "2" && (
        <>
          <div className="d-flex justify-content-end mb-2">
            <Button color="primary" onClick={() => setShowAssign(true)}>
              <i className="bx bx-plus me-1" />
              {t("Clients.Packages.Assign", "Paket Ata")}
            </Button>
          </div>
          <DataGrid
            key={refreshKey}
            hideBreadcrumbs
            isDetails
            listData={dataList}
            setDataList={setDataList}
            action={getClientPurchasedPackageList}
            paramsid={client.Id}
            columns={columns}
          />
          <AssignPackageModal
            clientId={client.Id}
            show={showAssign}
            setShow={setShowAssign}
            onSuccess={() => setRefreshKey((k) => k + 1)}
          />
        </>
      )}
    </React.Fragment>
  );
};

export default ClientPurchasedPackagesTab;
